/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientReminderModel } from '../../models/patient-reminder-model';

export interface GetPatientReminders$Params {
  patientID?: number;
}

export function GetPatientReminders(http: HttpClient, rootUrl: string, params?: GetPatientReminders$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientReminderModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientReminders.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientReminderModel>>;
    })
  );
}

GetPatientReminders.PATH = '/api/Supervisor/GetPatientReminders';
